(function () {
    'use strict';

    angular.module('app').factory('CustomerService', CustomerService);

    CustomerService.$inject = ['$rootScope', 'API', '$window'];

    function CustomerService($rootScope, API, $window) {
        var service = {};

        /**
         * This callback type is called `requestCallback` and is displayed as a global symbol.
         *
         * @callback requestCallback
         * @param {boolean} success
         * @param {Object} data
         */
        /**
         * @typedef MultiLanguageObject
         * @type {Object}
         * @property {string} en - String on English
         * @property {string} pl - String on Polish
         * @property {string} ru - String on Russian
         * @property {string} uk - String on Ukrainian
         */

        function initVars() {
            // Loyalty depends lists
        }

        $rootScope.$on('user-login', function () {
            initVars();
        });

        $rootScope.$on('user-register', function () {
            initVars();
        });

        $rootScope.$on('user-logout', function () {
            $rootScope.CUSTOMER_FIELDS = null;
            $window.localStorage.removeItem(`${$rootScope.appConfig.platform_key}_import`);
        });

        /**
         *
         * @param params
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.All = function (params, callback) {

            API.post('/customers', params, function (success, data) {
                if (success) {

                }
                callback(success, data);
            });
        };

        /**
         * Get customers ID for bulk operations
         *
         * @param {Object} post_data - POST data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.AllIds = function (post_data, callback) {
            API.post('/customer/customers_bulk_ids', post_data, function (success, data) {
                if (success) {

                }
                callback(success, data);
            });
        };

        /**
         * Return customers for business or loyalty
         *
         * @param id
         * @param loyalty_id
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.BusinessCustomer = function (id, loyalty_id, callback) {
            API.get('/customer/{0}?loyalty_id={1}'.format(id, loyalty_id), function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Return customers for business or loyalty
         *
         * @param loyalty_id
         * @param user_id_type
         * @param user_id_value
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.BusinessCustomerByType = function (loyalty_id, user_id_type, user_id_value, callback) {
            var params = {
                loyalty_id: loyalty_id,
                user_id_type: user_id_type,
                user_id_value: user_id_value
            }
            API.get('/customer?' + paramsToUrlQueryEncodeURIComponent(params), function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Add new customer
         *
         * @param {Object} post_data - POST data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.BusinessCustomerNew = function (post_data, callback) {
            API.post('/customer', post_data, callback);
        };

        /**
         * Change customer info
         *
         * @param {Object} post_data - POST data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.BusinessCustomerEdit = function (post_data, callback) {
            API.patch('/customer', post_data, callback);
        };

        /**
         * Card category assign to user account
         *
         * @param {Object} post_data - POST data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.AccessToAccount = function (post_data, callback) {
            API.patch('/customer/access', post_data, callback);
        };

        /**
         * Card category assign to user account
         *
         * @param {Object} post_data - POST data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.CardCategoryAssignToUser = function (post_data, callback) {
            API.post('/cards/category_assign', post_data, callback);
        };
        /**
         *
         * @param {string} customerId
         * @param {string} loyaltyId
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.Customer = function (customerId, loyaltyId, callback) {
            API.get('/customer/' + customerId + '?loyalty_id=' + loyaltyId, function (success, data) {
                callback(success, data);
            });
        };
        /**
         *
         * @param {string} customerId
         * @param {string} loyaltyId
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.CustomerLite = function (customerId, loyaltyId, callback) {
            API.get('/customer/' + customerId + '?lite=true&loyalty_id=' + loyaltyId, function (success, data) {
                callback(success, data);
            });
        };
        /**
         * Get all customer fields
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.CustomerFields = function (callback) {
            if ($rootScope.CUSTOMER_FIELDS) {
                callback(true, $rootScope.CUSTOMER_FIELDS);
            } else {
                API.get('/customer/field', function (success, data) {
                    if (success) {
                        $rootScope.CUSTOMER_FIELDS = data;
                    }
                    callback(success, data);
                });
            }
        };

        /**
         * Add new customer field
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.CustomerFieldAdd = function (data, callback) {
            API.post('/customer/field', data, function (success, data) {
                if (success) {
                    updateItemInList($rootScope.CUSTOMER_FIELDS, data);
                    //var orderBy = $filter('orderBy');
                    //$rootScope.CUSTOMER_FIELDS = orderBy($rootScope.CUSTOMER_FIELDS, 'sort_order', false);
                }
                callback(success, data);
            });
        };

        /**
         * Change customer field
         *
         * @param {string} id
         * @param {Object} data - POST data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.CustomerFieldChange = function (id, data, callback) {
            API.patch('/customer/field/' + id, data, function (success, data) {
                if (success) {
                    updateItemInList($rootScope.CUSTOMER_FIELDS, data);
                    //var orderBy = $filter('orderBy');
                    //$rootScope.CUSTOMER_FIELDS = orderBy($rootScope.CUSTOMER_FIELDS, 'sort_order', false);
                }
                callback(success, data);
            });
        };

        /**
         * Delete customer field
         *
         * @param {string} id
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.CustomerFieldDelete = function (id, callback) {
            API.del('/customer/field/' + id, function (success, data) {
                if (success) {
                    var i = $rootScope.CUSTOMER_FIELDS.indexOf(itemByIndex($rootScope.CUSTOMER_FIELDS, id));
                    $rootScope.CUSTOMER_FIELDS.splice(i, 1);
                }
                callback(success, data);
            });
        };

        /**
         *
         * @param {Object} data - POST data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.CustomerFieldsSaveOrders = function (data, callback) {
            API.patch('/customer/field', data, function (success, data) {
                if (success) {
                    $rootScope.CUSTOMER_FIELDS = data;
                }
                callback(success, data);
            });
        };

        /**
         * Import customers
         *
         * @param {Object} data - POST data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.Import = function (data, callback) {
            data.slow_request = true;
            return API.post('/customer/import', data, callback);
        };

        /**
         *
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.ImportPreferences = function (callback) {
            return API.get('/customer/import/preferences', callback);
        };

        /**
         * Return list of customers (retail and corporate)
         * @param {object} params - Parameters
         * @param {string} params.page - List page number
         * @param {string} params.count - Objects on page
         * @param {'all' | 'customer' | 'corporate-customer'} params.customer_type - Customer type filtering
         * @param {string} params.search_text - Filter by search string (contains criteria) in main text fields (phone, email, name)
         * @param {'title'} params.sort - Sort field name
         * @param {'asc'|'desc'} params.order - Sort direction
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.AllTypeCustomers = function (params, callback) {
            API.get('/all_type_customers?' + paramsToUrlQueryEncodeURIComponent(params), callback);
        };

        /**
         * Return customers special accounts list
         *
         * @param {string} userId - User Id
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetCustomerSpecialAccounts = function (userId, callback) {
            return API.get('/customer/' + userId + '/special_accounts', callback);
        };

        /**
         * Add special account for customer
         *
         * @param {string} userId - User Id
         * @param {Object} data - POST data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.AddSpecialAccountCustomer = function (userId, data, callback) {
            return API.post('/customer/' + userId + '/special_accounts', data, callback);
        };

        /**
         * Return customers special account
         *
         * @param {string} userId - User Id
         * @param {string} accountId - Customer account Id
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetCustomerSpecialAccount = function (userId, accountId, callback) {
            return API.get('/customer/' + userId + '/special_accounts/' + accountId, callback);
        };

        /**
         * Modify special account for customer
         *
         * @param {string} userId - User Id
         * @param {string} accountId - Customer account Id
         * @param {Object} data - POST data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.UpdateSpecialAccountCustomer = function (userId, accountId, data, callback) {
            return API.patch('/customer/' + userId + '/special_accounts/' + accountId, data, callback);
        };

        /**
         * Return special account available goods list for customer
         *
         * @param {string} userId - User Id
         * @param {string} accountId - Customer account Id
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetAvailableGoodsCustomer = function (userId, accountId, callback) {
            return API.get('/customer/' + userId + '/special_accounts/' + accountId + '/goods', callback);
        };

        return service;
    }

})();
